import styled from '@emotion/styled'

export const Top = styled.div`
  margin-bottom: 20px;
`

export const Options = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`
